<msal-redirect />
<router-outlet />
